import { mapGetters } from "vuex";

export const handleSocket = {
    props: {
        i18n: Object,
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            sound: "roulette/fetchSound",
        }),
    },
    methods: {
        getGameTranslation(gameName) {
            switch (gameName) {
                case "Да-нет":
                    return this.$t("games.yesNo");
                case "Кручу-верчу":
                    return this.$t("games.twistingTurning");
                case "Дурак на раздевание":
                    return this.$t("games.theUndressingFool");

                default:
                    return gameName;
            }
        },
        handleSocket(msg) {
            switch (msg.event) {
                case "roulette_prize":
                    setTimeout(() => {
                        let roulettePromise;
                        if (msg.data.winner) {
                            let winSound =
                                document.getElementById("win-roulette-sound");
                            if (winSound /*&& this.sound*/)
                                roulettePromise = winSound.play();
                        } else {
                            let loseSound = document.getElementById(
                                "lose-roulette-sound"
                            );
                            if (loseSound /*&& this.sound*/)
                                roulettePromise = loseSound.play();
                        }
                        if (roulettePromise) {
                            roulettePromise
                                .then(() => {
                                    return;
                                })
                                .catch(() => {
                                    return;
                                });
                        }
                        this.$modal.show("roulette-result", { data: msg.data });
                    }, 9000);
                    break;
                case "balance_changed":
                    this.$store.dispatch("user/setBalance", msg.data);
                    break;
                case "account_balance_changed":
                    this.$store.dispatch("user/setAccountBalance", msg.data);
                    break;
                case "replenishment":
                    let text = msg.data.success
                        ? this.$t("balance.balanceSuccessfullyReplenished")
                        : this.$t("balance.paymentDeclined");
                    this.$modal.show("dialog", {
                        title: this.$t("balance.balanceReplenishment"),
                        text: text,
                        buttons: [
                            {
                                title: this.$t("mixins.ok"),
                            },
                        ],
                    });
                    break;
                case "event":
                    if (this.$route.name == "events") {
                        this.$store.dispatch(
                            "events/addNewFromFront",
                            msg.data
                        );
                        return;
                    }
                    this.$store.dispatch("init/setCounters", {
                        counter: "events",
                        increment: true,
                        count: 1,
                    });
                    break;
                case "chat_message":
                    let messagePromise = document
                        .getElementById("message-sound")
                        .play();
                    if (messagePromise) {
                        messagePromise
                            .then(() => {
                                return;
                            })
                            .catch(() => {
                                return;
                            });
                    }
                    if (this.$route.name == "threads") {
                        return;
                    }
                    this.$store.dispatch("init/setCounters", {
                        counter: "messages",
                        increment: true,
                        count: 1,
                    });
                    break;
                case "guest":
                    if (this.$route.name == "guests") {
                        return;
                    }
                    this.$store.dispatch("init/setCounters", {
                        counter: "guests",
                        increment: true,
                        count: 1,
                    });
                    break;
                case "invitation":
                    let invitePromise = document
                        .getElementById("invite-sound")
                        .play();
                    if (invitePromise) {
                        invitePromise
                            .then(() => {
                                return;
                            })
                            .catch(() => {
                                return;
                            });
                    }
                    this.$notify({
                        group: "invite",
                        title: this.$t("balance.invitationGame"),

                        text:
                            this.$t("balance.user") +
                            msg.data.from_user.name +
                            this.$t("balance.invitesYouGame") +
                            // msg.data.name +
                            this.getGameTranslation(msg.data.name) +
                            "»",
                        duration: -1,
                        data: {
                            gameId: msg.data.id,
                            lobbyId: msg.data.lobby,
                        },
                    });
                    break;
                default:
                    break;
            }
        },
    },
};
